/* src/app/modules/portal/components/system-root/system-root.component.scss */
:host {
  --gap: 1rem;
  flex: 1 0;
  display: flex;
  flex-direction: column;
}
#details-component-overview-template {
  display: flex;
  flex-direction: row;
  margin-top: 0.5rem;
  width: 100%;
  justify-content: flex-start;
}
#system-root {
  grid-area: 1/1/span 12/span 12;
}
#system-details {
  margin-bottom: 0.5rem;
  padding-left: 4px;
  grid-area: 1/1/1/span 12;
}
#content {
  margin-bottom: 0.5rem;
  grid-area: 2/1/span 11/span 12;
  overflow-y: hidden;
  display: flex;
  flex-direction: column;
  flex: 1 0;
}
#psmOverviewIframe {
  border: 0px;
  width: 100%;
  height: 95%;
}
.error {
  flex: 1 0;
  display: flex;
  align-self: center;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.error img {
  max-width: 400px;
}
.error > * {
  text-align: center;
}
.layout {
  display: flex;
  flex: 1 0;
  flex-direction: column;
}
sh-spinner {
  margin: auto;
}
.content {
  display: flex;
  flex-direction: column;
  flex: 1 0;
  padding: var(--gap);
}
[screen-desktop-large] :host-context app-system-details,
[screen-desktop] :host-context app-system-details {
  width: 16.6666666667%;
}
[screen-desktop-large] :host-context .content,
[screen-desktop] :host-context .content {
  width: 83.3333333333%;
  box-sizing: border-box;
}
[screen-desktop-large] :host-context .layout,
[screen-desktop] :host-context .layout {
  flex-direction: row;
  height: 100%;
}
[screen-desktop-large] :host-context .widgets,
[screen-desktop] :host-context .widgets {
  flex-direction: column;
}
[screen-tablet] :host-context .error img,
[screen-phone] :host-context .error img {
  max-width: 50%;
}
[screen-tablet] :host-context app-system-details,
[screen-phone] :host-context app-system-details {
  width: 100%;
}
[screen-tablet] :host-context .content,
[screen-phone] :host-context .content {
  width: calc(100% - 2rem);
}
/*# sourceMappingURL=system-root.component.css.map */
